import { Button, ConfirmDialog, IButtonProps } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { actions } from 'Data/ReduxViewModels/WorksheetBatchUpdate';
import { hasEmptyValue } from 'Lib/Any';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WorksheetBatchUpdateCheckedWorksheetsDialog from './WorksheetBatchUpdateCheckedWorksheetsDialog';

type WorksheetBatchUpdateApplyButtonProps = IButtonProps;

/**
 * Button that will apply the entered update values to the selected worksheets.
 */
let WorksheetBatchUpdateApplyButton: React.FC<WorksheetBatchUpdateApplyButtonProps> = ({ disabled, ...otherProps }) => {
  const dispatch = useDispatch();

  const canApply = useSelector(
    (state) =>
      state.worksheetBatchUpdate.status.initialised &&
      state.worksheetBatchUpdate.status.queryReady &&
      !state.worksheetBatchUpdate.status.refreshingWorksheets &&
      !state.worksheetBatchUpdate.status.configuring &&
      !state.worksheetBatchUpdate.status.checking &&
      Object.values(state.worksheetBatchUpdate.worksheetsState).some((w) => w.selected)
  );
  const applying = useSelector((state) => state.worksheetBatchUpdate.status.applyingUpdate);
  const missingData = useSelector((state) =>
    Object.values(state.worksheetBatchUpdate.updateData).some((v) => hasEmptyValue(v))
  );

  const anyCheckedWorksheets = useSelector((state) =>
    Object.entries(state.worksheetBatchUpdate.worksheets).some(
      ([worksheetId, worksheet]) =>
        //locked, but can be unchecked
        worksheet.status.readonly.locked &&
        worksheet.status.readonly.uncheckAllowed &&
        //and selected for update
        state.worksheetBatchUpdate.worksheetsState[worksheetId].selected
    )
  );

  const [checkedWorksheetDialogVisible, setCheckedWorksheetDialogVisible] = useState<boolean>(false);
  const applyUpdateHandleCheckedWorksheets = () => {
    if (anyCheckedWorksheets) {
      setCheckedWorksheetDialogVisible(true);
    } else {
      dispatch(actions.applyUpdate({}));
    }
  };

  return (
    <>
      <WorksheetBatchUpdateCheckedWorksheetsDialog
        visible={checkedWorksheetDialogVisible}
        onClose={() => setCheckedWorksheetDialogVisible(false)}
        onContinue={() => dispatch(actions.uncheckWorksheetsAndUpdate())}
      />

      <ConfirmDialog
        confirm={missingData}
        confirmButtonText="Continue"
        confirmText="Update fields without a value will be cleared on the selected worksheets. Do you want to continue?"
        confirmTitle="Incomplete update fields"
      >
        <Button
          primary
          onClick={applyUpdateHandleCheckedWorksheets}
          loading={applying}
          disabled={disabled || !canApply}
          {...otherProps}
        >
          Apply to Selected
        </Button>
      </ConfirmDialog>
    </>
  );
};

WorksheetBatchUpdateApplyButton = withInjectedProps(WorksheetBatchUpdateApplyButton);

export default WorksheetBatchUpdateApplyButton;
export { WorksheetBatchUpdateApplyButton };
